import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AlertIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "AlertIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M12.0005 22C6.48633 22 2 17.5142 2 12C2 6.48584 6.48584 2 12 2C17.5142 2 22 6.48584 22 12C22 17.5142 17.5142 22 12.0005 22ZM12.0005 3C7.03759 3 3 7.0376 3 12C3 16.9624 7.0376 21 12 21C16.9624 21 21 16.9624 21 12C21 7.0376 16.9629 3 12.0005 3Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 8.00009C11.7236 8.00009 11.5 8.22372 11.5 8.50009V13.0876C11.5 13.364 11.7236 13.5876 12 13.5876C12.2764 13.5876 12.5 13.364 12.5 13.0876V8.50009C12.5 8.22372 12.2764 8.00009 12 8.00009Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.9961 15.589C11.8662 15.589 11.7358 15.649 11.646 15.7389C11.5561 15.8287 11.5058 15.9591 11.5058 16.089C11.5058 16.1588 11.5161 16.2291 11.5361 16.2887C11.5659 16.3487 11.6059 16.399 11.646 16.4488C11.8359 16.6388 12.166 16.629 12.3559 16.4488C12.396 16.399 12.436 16.3487 12.4663 16.2887C12.4858 16.2291 12.4961 16.1588 12.4961 16.089C12.4961 15.9591 12.4463 15.8287 12.3559 15.7389C12.2661 15.649 12.1362 15.589 11.9961 15.589Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8307 16.2795C11.8015 16.2429 11.7823 16.2174 11.7683 16.1929C11.7608 16.1646 11.7558 16.1284 11.7558 16.0889C11.7558 16.0197 11.7836 15.9547 11.8228 15.9156C11.8708 15.8676 11.9393 15.8389 11.9961 15.8389C12.0655 15.8389 12.133 15.8695 12.1792 15.9156C12.2179 15.9542 12.2461 16.0191 12.2461 16.0889C12.2461 16.1277 12.2412 16.1641 12.2339 16.193C12.2198 16.2171 12.201 16.2421 12.1734 16.2768C12.0758 16.3588 11.9167 16.3561 11.8307 16.2795ZM11.4692 16.6256C11.7623 16.9187 12.2475 16.8963 12.528 16.6302L12.5402 16.6186L12.5532 16.6024C12.5917 16.5546 12.6467 16.4862 12.6895 16.4012L12.698 16.3844L12.7038 16.3665C12.7328 16.2784 12.7461 16.1813 12.7461 16.0889C12.7461 15.899 12.6742 15.7027 12.5322 15.5616C12.3987 15.4281 12.2069 15.3389 11.9961 15.3389C11.7931 15.3389 11.6009 15.4304 11.4692 15.5621C11.3286 15.7026 11.2558 15.8984 11.2558 16.0889C11.2558 16.1812 11.2691 16.279 11.2991 16.3683L11.3046 16.3845L11.3122 16.3997C11.3547 16.4856 11.4101 16.5544 11.4485 16.6021C11.4494 16.6032 11.4503 16.6043 11.4511 16.6054L11.4596 16.616L11.4692 16.6256ZM12 13.3376C11.8617 13.3376 11.75 13.2259 11.75 13.0876V8.50008C11.75 8.36178 11.8617 8.25008 12 8.25008C12.1383 8.25008 12.25 8.36178 12.25 8.50008V13.0876C12.25 13.2259 12.1383 13.3376 12 13.3376ZM11.25 13.0876C11.25 13.5021 11.5856 13.8376 12 13.8376C12.4144 13.8376 12.75 13.5021 12.75 13.0876V8.50008C12.75 8.08563 12.4144 7.75008 12 7.75008C11.5856 7.75008 11.25 8.08563 11.25 8.50008V13.0876Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default AlertIcon;
